import * as d3 from 'd3'
export default {
  methods: {

    draw_Table(selection, chtData) {

      let tbl = this.table
    
      let header = selection
      .append('g')
      .attr('transform', `translate(${0}, ${this.chart.height + .5})`)
      .style('font-family', 'roboto')

      this.timeline.xItems.forEach((d,i)=> {
        this.gmx_Line(header, d.sx, d.sx, 0, tbl.headHeight + tbl.height, tbl.stroke.medium, .5, 1)
      })
      

      tbl.y = tbl.headHeight+.5
      // Data Table -----------------------------------------------------------------------------------------------
      let tblCanvas = header
      .append('g')
      .attr('transform', `translate(${0}, ${0})`)

      this.gmx_Line(tblCanvas, tbl.x, this.chart.width, tbl.y, tbl.y, tbl.stroke.medium, .5, 1)
      this.gmx_Line(tblCanvas, tbl.x, tbl.x, tbl.y, tbl.y+tbl.height, tbl.stroke.medium, .5, 1)

      let item  = this.timeline.xItems

      chtData.forEach((d,i)=> {

        let y_ = tbl.y
        this.chart.styles.filter(f=> f.tbl == 'Y').forEach((col,c)=> {
          if(i==0) {
            let x_ = tbl.itemAlign=='middle' ? tbl.x/2 : tbl.itemAlign=='end' ? -5: tbl.x + 5

            tblCanvas
            .append('text')
            .attr('transform', `translate(${x_}, ${y_+ tbl.lineHeight/2 + (tbl.tSize*0.36)})`)
            .attr('font-size', tbl.tSize).attr('fill', tbl.tColor.item).attr('text-anchor', tbl.itemAlign)
            .text(col.name)
          }
          
          tblCanvas
          .append('text')
          .attr('transform', `translate(${item[i].mx}, ${y_+ tbl.lineHeight/2 + (tbl.tSize*0.36)})`)
          .attr('font-size', tbl.tSize).attr('fill', tbl.tColor.val).attr('text-anchor', 'middle')
          .text(d[col.code])
          .call(this.call_LINK, d, {
            type: 'TABLE',
            st: {...col}
          })

          y_ += tbl.lineHeight
          this.gmx_Line(tblCanvas, tbl.x, this.chart.width, y_, y_, (y_==tbl.y+tbl.height) ? tbl.stroke.medium : tbl.stroke.light, .5, 1)
        })

      })

      this.gmx_Line(tblCanvas, this.chart.width, this.chart.width, 0, tbl.y+tbl.height,  tbl.stroke.medium, .5, 1)
    },

  }
}
